/**
 * 设置返回按钮跳转
 * 适用于随手记
 */
define('util/client-getBackClose',['util/client-bridge'], function(clientBridge) {
    return function(level) {
        if (CLIENT_DATA.client === 'ssj' && !isNaN(level)) {
            clientBridge.call(clientBridge.uriSuishouji('getBackClose', {
                isOpenBackClose: level
            }));
            // IOS客户端需要以下代码支持
            window.getBackClose = level;
        }
    };
});

